export default "__VITE_ASSET__zRQjI6Zc__"